import { clsx } from 'clsx';
import { FunctionComponent } from 'react';
import styles from './Avatar.module.scss';
import UnassignedAvatar from './UnassignedAvatar';

interface AvatarProps {
    imageUrl: string | null;
    className?: string;
}

export const Avatar: FunctionComponent<AvatarProps> = props => {
    return props.imageUrl === null ? (
        <UnassignedAvatar className={props.className} />
    ) : (
        <img
            src={props.imageUrl}
            className={clsx(styles.avatar, props.className)}
        />
    );
};

export default Avatar;
